module.exports = __webpack_public_path__ + "static/media/aeropress.b301dae4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/aeropress.svg
// module id = 28
// module chunks = 0